import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import * as qs from "query-string";
import Modal from "react-modal";

import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import Box from "@material-ui/core/Box";

import dropArrow from "@safecv/assets/Images/dropArrow.svg";
import docList from "@safecv/assets/Images/docList.svg";
import popout from "@safecv/assets/Images/popout.svg";
import UploadModal from "./UploadModal";

const customModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    padding: "0px",
    width: "750px",
    overflow: "hidden",
    borderRadius: "0px",
    transform: "translate(-50%, -50%)",
  },
};

Modal.defaultStyles.overlay.backgroundColor = "rgb(0, 0, 0, 0.5)";

function SupportDocLoader(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const [defaultDoc, setdefaultDoc] = useState(props.planName);
  const urlSearch = qs.parse(window.location.search);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleModalOpen = () => {
    setIsModalOpen(true);
    setAnchorEl(null);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setAnchorEl(null);
  };

  useEffect(() => {
    if (!props.isSupportDocSelected) {
      setdefaultDoc(props.planName);
    }
  }, [props.isSupportDocSelected]);

  useEffect(() => {
    let currentObject =
      props.additionalDocs &&
      props.additionalDocs.filter((item) => {
        return item.id === parseInt(urlSearch.id);
      });
    if (currentObject && currentObject.length > 0) {
      setdefaultDoc(currentObject[0].name);
      props.setCurrentDoc(currentObject[0].name);
    } else {
      setdefaultDoc(props.planName);
      props.setCurrentDoc(props.planName);
    }
  }, [urlSearch.id, props.additionalDocs]);

  const addDocs =
    props.additionalDocs &&
    props.additionalDocs.map((item) => {
      return (
        <a
          key={item.id}
          className="supportingDocLink"
          href={
            window.location.origin +
            "/plan/" +
            props.jobId +
            "/supportingDocs?id=" +
            item.id
          }
          target="_blank"
        >
          <span title={item.name}> {item.name} </span>
          <img alt="" src={popout} className="doc-icons" />
        </a>
      );
    });

  return (
    <div className="supportDocShowContainer">
      <img alt="" src={docList} className="doc-icons" />
      <Button
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
        className="mainButton"
      >
        <div className="planHolder">
          <Box component="div" textOverflow="ellipsis" overflow="hidden">
            {defaultDoc}
          </Box>
        </div>

        <img alt="" src={dropArrow} className="doc-icons" />
      </Button>
      <Menu
        id="simple-menu-support"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <div className="planDoc" onClick={handleClose}>
          <label>Plan Document</label>
          <br />
          <a
            className="supportingDocLink"
            href={
              window.location.origin + "/plan/" + props.jobId + "/pdfviewer"
            }
            target="_blank"
          >
            <span className="planName" title={props.planName}>
              {props.planName}
            </span>
            <img alt="" src={popout} className="doc-icons" />
          </a>
        </div>
        <br />
        {props.additionalDocs?.length > 0 && (
          <div className="OtherDocs" onClick={handleClose}>
            <label>Other Documents</label>
            <br />
            <div className="anchorContainer"> {addDocs}</div>
          </div>
        )}
        <div className="addDocButton" onClick={handleModalOpen}>
          + Add documents
        </div>
      </Menu>

      <Modal
        ariaHideApp={false}
        isOpen={isModalOpen}
        style={customModalStyles}
        onRequestClose={handleModalClose}
        contentLabel="Document Modal"
      >
        <UploadModal handleModalClose={handleModalClose} jobId={props.jobId} />
      </Modal>
    </div>
  );
}

const mapStatetoProps = (state) => ({
  additionalDocs: state.verification.additionalDocs,
});

export default connect(mapStatetoProps)(SupportDocLoader);
